import { smStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const TitleTabsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .price-fundraising-title-tabs {
    overflow: auto;
    flex-wrap: nowrap;
    overflow-x: scroll;
    width: calc(100% - 0px);

    ::-webkit-scrollbar {
      width: 0px;
      height: 0px;
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 0px;
      background: hsla(215, 17%, 59%, 0.2);
    }
    &::-webkit-scrollbar-track {
      border-radius: 0px;
    }
  }
`

export const TitleTabStyled = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: inherit;
  white-space: nowrap;

  ${smStyle} {
    font-size: 24px;
  }
`

export const TitleTabsPStyled = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  color: var(--color-text-2);
`
export const FundraisingInputStyled = styled.div`
  height: 40px;
`
